import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PlayerHeader from './PlayerHeader';
import PlayerHero from './PlayerHero';
import PlayerTabs from './PlayerTabs';
import PlayerStats from './PlayerStats';
import PlayerCharts from './PlayerCharts';
import PlayerCareer from './PlayerCareer';
import PlayerTeammates from './PlayerTeammates';
import SimilarPlayers from './SimilarPlayers';
import PlayerNeuro from './PlayerNeuro';
const PlayerDetail = () => {
  const {
    playerId
  } = useParams();
  const [activeTab, setActiveTab] = useState('stats');
  return <div className="w-full max-w-7xl mx-auto pb-12 px-4" data-id="element-235">
      <PlayerHeader data-id="element-236" />
      <div className="mt-4 flex gap-6" data-id="element-237">
        <div className="flex-1" data-id="element-238">
          <PlayerHero data-id="element-239" />
          <PlayerTabs activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-240" />
          <div className="mt-4" data-id="element-241">
            {activeTab === 'stats' && <PlayerStats data-id="element-242" />}
            {activeTab === 'neuro' && <PlayerNeuro data-id="element-243" />}
            {activeTab === 'charts' && <PlayerCharts data-id="element-244" />}
            {activeTab === 'box_score' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-245">
                Box Score Content
              </div>}
            {activeTab === 'matches' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-246">
                Matches Content
              </div>}
            {activeTab === 'team_mates' && <PlayerTeammates data-id="element-247" />}
            {activeTab === 'career' && <PlayerCareer data-id="element-248" />}
            {activeTab === 'news' && <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-249">
                News Content
              </div>}
          </div>
        </div>
        <div className="w-64" data-id="element-250">
          <SimilarPlayers data-id="element-251" />
        </div>
      </div>
    </div>;
};
export default PlayerDetail;